import appApi from '../../../../../api/app-api';
import globalSettingsStores from '../../../../../stores/settings-stores';
import { toast } from 'react-toastify';

export const addNewScholarshipFunderOperation = async (
  funderName: string,
  setIsLoading: (loading: boolean) => any,
  closeDialog: () => any,
) => {
  if (!funderName.trim()) {
    return;
  }

  if (funderName.length < 3 || funderName.length > 60) {
    toast.warn('על שם גוף המממן להיות בין 3 ל - 60 תווים');
  }

  setIsLoading(true);
  try {
    const response = await appApi.addScholarshipFunder(funderName);
    if (response.data.ok) {
      await globalSettingsStores.fetchSetting();
      closeDialog();
    }
  } catch (error) {
    console.error(
      `addNewScholarshipFunderOperation is failed with the error: ${error}`,
    );
  } finally {
    setIsLoading(false);
  }
};
